import { html, TemplateResult, LitElement} from 'lit';
import { customElement } from 'lit/decorators.js';
import globalStyles from './styles/outline-footer-block.global.pcss?inline';
import encapsulatedStyles from './styles/outline-footer-block.inner.pcss?inline';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';

/**
 * The OutlineFooterBlock component
 * @element outline-footer-block
 */
const componentName = 'outline-footer-block';

@customElement('outline-footer-block')
export class OutlineFooterBlock extends LitElement {
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
    encapsulatedCSS: encapsulatedStyles,
  });

  render(): TemplateResult {
    return html`
      <section class="outline-footer-block">
        <div class="description-wrapper">
          <slot name="description"></slot>
        </div>
        <div class="chip-wrapper">
          <slot name="chips"></slot>
        </div>
      </section>
    `;
  }
}
/**
 * Declare the component in the global HTMLElementTagNameMap
 */
declare global {
  interface HTMLElementTagNameMap {
    [componentName]: OutlineFooterBlock;
  }
}